export const fullSeries: { [key: string]: number } = {
  'Lorinser MAYBACH S650': 3000,
  'mini jcw countryman': 47,
  '巴博斯 smart forfour': 103,
  'panamera e-hybrid': 153,
  'mini jcw clubman': 45,
  '巴博斯 smart fortwo': 102,
  'cayenne e-hybrid': 156,
  'mini countryman': 42,
  '凯迪拉克ct6 plug-in': 856,
  'lorinser ms500l': 2938,
  '上汽maxus euniq 5': 3468,
  'wey vv7 gt phev': 4151,
  'sprinter ls500': 27,
  '福特f-150 raptor': 571,
  '天逸 c5 aircross': 1642,
  'lorinser gs500': 1839,
  '云逸 c4 aircross': 2817,
  'smart forfour': 50,
  f12berlinetta: 492,
  'lorinser vs系列': 1580,
  '君马meet 3(美图3)': 1919,
  '君马seek 5(赛克5)': 2919,
  'sf90 stradale': 3726,
  '上汽maxus fcv80': 4179,
  'metris ms500': 28,
  'mini clubman': 39,
  'smart fortwo': 49,
  '克莱斯勒300c(进口)': 875,
  '沃尔沃xc90 phev': 1276,
  '众泰t600 coupe': 1577,
  '上汽maxus eg10': 1578,
  '沃尔沃xc60 phev': 1792,
  '上汽maxus ev80': 1825,
  'sitech dev 1': 2840,
  'la festa 菲斯塔': 2889,
  '长安cs85 coupe': 2993,
  '上汽maxus ev30': 3151,
  '上汽maxus rv80': 3165,
  '奥迪q2l e-tron': 3337,
  'wey vv7 phev': 3714,
  '上汽maxus rg10': 4137,
  '奔驰a级amg(进口)': 248,
  凯雷德escalade: 853,
  granturismo: 1019,
  '上汽maxus g10': 1211,
  '上汽maxus t60': 1212,
  '上汽maxus v80': 1213,
  'model 3(进口)': 1563,
  '上汽maxus d90': 1627,
  '沃尔沃xc40(进口)': 1762,
  '大捷龙phev(进口)': 1799,
  '长安cs75 phev': 2853,
  '沃尔沃s90 phev': 2937,
  '上汽maxus g50': 2984,
  '长安欧尚a600 ev': 2986,
  '长安cs35 plus': 3052,
  '上汽maxus d60': 3153,
  '长安cs75 plus': 3196,
  '上汽maxus g20': 3279,
  'beijing·eu7': 3349,
  '上汽maxus v90': 3441,
  '上汽maxus t70': 3475,
  '长安cs55 plus': 4223,
  'v8 vantage': 63,
  '阿斯顿·马丁db11': 66,
  宝马2系多功能旅行车: 130,
  'yaris l 致享': 532,
  'yaris l 致炫': 533,
  '哈弗h6 coupe': 650,
  grancabrio: 1020,
  'c4 picasso': 1385,
  '奥迪a6l phev': 1707,
  'polestar 1': 1778,
  'encino 昂希诺': 1814,
  '荣威marvel x': 1954,
  '东风·瑞泰特em30': 2796,
  '风光580 phev': 2870,
  '东风·瑞泰特em10': 3012,
  'beijing·u7': 3065,
  'polestar 2': 3166,
  'beijing·x3': 3390,
  车驰sprinter: 3730,
  '荣威rx5 emax': 4075,
  'wey vv7 gt': 4131,
  'alpina b4': 3,
  '阿斯顿·马丁dbs': 67,
  '奥迪q7 phev': 88,
  '宝马x5 phev': 129,
  '宝马x1 phev': 149,
  '奔驰glc(进口)': 226,
  奔驰cla级amg: 249,
  '奔驰gla amg': 254,
  '奔驰gle amg': 256,
  '奔驰gls amg': 258,
  gtc4lusso: 495,
  广汽吉奥gp150: 631,
  '凯迪拉克ats-l': 855,
  aventador: 878,
  '马自达3 昂克赛拉': 1014,
  '新凯v-class': 1346,
  '中华h230 ev': 1513,
  '众泰z500 ev': 1547,
  '卡升v-class': 1586,
  '奔驰glc amg': 1650,
  portofino: 1699,
  '鑫源x30l ev': 1772,
  '长安cs15 ev': 1780,
  揽胜运动版phev: 1802,
  '汉腾x7 phev': 1808,
  瑞驰新能源ec35: 1910,
  瑞驰新能源ek05: 1918,
  '阿斯顿·马丁dbx': 2182,
  '众泰t300 ev': 2797,
  '领克01 phev': 2883,
  '起亚k5 phev': 2901,
  '卡尔森 cca22': 3016,
  罗夫哈特gr500: 3062,
  't-cross途铠': 3066,
  瑞驰新能源ec31: 3132,
  '领克02 phev': 3144,
  '帝豪gl phev': 3331,
  '领克03 phev': 3346,
  '捷途x70s ev': 3353,
  '起亚k3 phev': 3371,
  '荣威rx5 max': 3381,
  '车驰v-class': 3732,
  罗夫哈特mr500: 3830,
  '银隆5024 ev': 3898,
  福克斯active: 3921,
  '傲旋v-class': 4092,
  '大切诺基(进口)': 18,
  'mini jcw': 44,
  vanquish: 64,
  '奥迪a3(进口)': 72,
  '奥迪a4(进口)': 75,
  '奥迪a6(进口)': 78,
  '宝马1系(进口)': 115,
  '宝马5系(进口)': 120,
  宝马7系phev: 123,
  宝马5系phev: 147,
  panamera: 152,
  北汽威旺m50f: 187,
  '奔驰a级(进口)': 218,
  '奔驰c级(进口)': 221,
  '奔驰e级(进口)': 222,
  'c-trek蔚领': 412,
  东风小康k07s: 473,
  东风小康k05s: 474,
  东风小康ec36: 475,
  华泰iev230: 706,
  华泰xev260: 707,
  '捷豹f-pace': 795,
  '捷豹f-type': 796,
  '雷克萨斯rc f': 898,
  '力帆330 ev': 913,
  '揽胜极光(进口)': 984,
  迈凯伦570gt: 1027,
  '雪铁龙c3-xr': 1376,
  英菲尼迪q50l: 1422,
  英菲尼迪qx50: 1423,
  英菲尼迪qx30: 1433,
  英菲尼迪qx60: 1435,
  英菲尼迪qx70: 1436,
  英菲尼迪qx80: 1437,
  长安欧尚cx70: 1471,
  长安欧尚a600: 1472,
  长安欧尚a800: 1566,
  华泰ev160b: 1582,
  '长城c30 ev': 1585,
  华泰ev160r: 1608,
  长安欧尚x70a: 1662,
  'kx cross': 1697,
  '启腾m70 ev': 1739,
  卡威k150gt: 1768,
  '宝马x2(进口)': 1783,
  '名爵6 phev': 1795,
  '风行s50 ev': 1810,
  '东南dx3 ev': 1811,
  '开沃d11 ev': 1828,
  '奔腾b30 ev': 1843,
  '鑫源t20 ev': 1849,
  '猎豹cs9 ev': 1913,
  开沃d07创业者: 1921,
  '捷豹i-pace': 2074,
  '奥迪e-tron': 2102,
  '开瑞k50 ev': 2184,
  依维柯威尼斯之旅: 2227,
  江淮ieva50: 2311,
  奔驰e级phev: 2716,
  swm斯威g01: 2779,
  '捷豹e-pace': 2816,
  '力帆650 ev': 2821,
  迈凯伦600lt: 2961,
  '开瑞k60 ev': 2979,
  '途观l phev': 3001,
  '长安之星9 ev': 3022,
  '奔腾x40 ev': 3027,
  '英致737 ev': 3033,
  '力帆820 ev': 3055,
  名爵ezs纯电动: 3080,
  '广汽本田ve-1': 3096,
  江淮ieva60: 3099,
  '佳宝v80 ev': 3133,
  北汽新能源ex5: 3158,
  长安欧尚长行ev: 3329,
  北汽新能源ex3: 3347,
  北汽新能源ec5: 3348,
  '启辰d60 ev': 3351,
  '启辰t60 ev': 3453,
  '东风本田x-nv': 3480,
  迈莎锐ms580: 3529,
  swm斯威g05: 3721,
  '谢尔比f-150': 3756,
  庆铃五十铃t17: 3805,
  风光580pro: 3973,
  北汽新能源eu5: 4074,
  '众泰m10 ev': 4088,
  五菱宏光plus: 4159,
  '神骐t10 ev': 4221,
  '鑫源t50 ev': 4301,
  swm斯威x7: 53,
  swm斯威x3: 54,
  'wey vv7': 55,
  stelvio: 59,
  宝马2系旅行车: 144,
  cayenne: 155,
  北汽幻速h2v: 172,
  北汽威旺s50: 186,
  北汽威旺306: 189,
  北汽威旺m20: 190,
  北汽威旺307: 191,
  北汽威旺m30: 192,
  北汽新能源ec: 194,
  北汽新能源eu: 197,
  北汽新能源ex: 201,
  北京bw007: 206,
  奔驰c级amg: 250,
  奔驰e级amg: 252,
  奔驰s级amg: 253,
  奔驰g级amg: 255,
  北汽昌河q25: 361,
  北汽昌河q35: 362,
  北汽昌河m70: 363,
  北汽昌河m50: 368,
  '高尔夫(进口)': 377,
  东风风度mx6: 433,
  东风风神a60: 451,
  东风风神ax3: 455,
  东风风神ax5: 456,
  东风风神ax7: 457,
  东风小康k01: 458,
  东风小康k02: 461,
  东风小康c31: 462,
  东风小康c32: 463,
  东风小康c37: 470,
  东风小康c35: 471,
  东风小康c36: 472,
  '福克斯(进口)': 561,
  '探险者(进口)': 564,
  mustang: 567,
  '福特f-150': 568,
  海马s5青春版: 678,
  江淮iev6e: 749,
  江铃e200l: 779,
  江铃e100b: 786,
  江铃e200n: 789,
  华晨金杯750: 805,
  金旅大海狮ev: 830,
  凯迪拉克ct6: 859,
  凯迪拉克xts: 860,
  凯迪拉克xt5: 861,
  '大捷龙(进口)': 876,
  huracán: 877,
  '吉姆尼(进口)': 966,
  '马自达mx-5': 1003,
  '马自达cx-4': 1008,
  '马自达cx-5': 1016,
  levante: 1023,
  迈凯伦540c: 1026,
  迈凯伦570s: 1028,
  迈凯伦720s: 1032,
  骐达tiida: 1143,
  日产nv200: 1167,
  日产zn厢式车: 1170,
  '帕杰罗(进口)': 1206,
  'model s': 1254,
  'model x': 1255,
  沃尔沃xc90: 1277,
  沃尔沃xc60: 1282,
  'mu-x牧游侠': 1296,
  依维柯ouba: 1420,
  英菲尼迪q50: 1426,
  英菲尼迪q70: 1427,
  英菲尼迪esq: 1428,
  英菲尼迪q60: 1438,
  'wey vv5': 1611,
  '奥迪tt rs': 1634,
  东风风神e70: 1655,
  '讴歌tlx-l': 1687,
  东风风神ax4: 1689,
  江淮iev7s: 1706,
  北汽昌河m60: 1753,
  '电咖·ev10': 1785,
  '马自达cx-3': 1790,
  '菱智m5 ev': 1793,
  蒙迪欧phev: 1809,
  't-roc探歌': 1977,
  '汉腾x5 ev': 2145,
  'wey vv6': 2831,
  '红旗e-hs3': 2861,
  inspire: 2875,
  '卡罗拉双擎e+': 2881,
  '宋max dm': 2887,
  索纳塔phev: 2907,
  凯迪拉克xt4: 2971,
  帕萨特phev: 2989,
  '马自达cx-8': 3002,
  '领途k-one': 3036,
  '秦pro dm': 3048,
  '秦pro ev': 3049,
  '新宝骏rs-5': 3053,
  富康es500: 3076,
  江淮ievs4: 3093,
  '森雅r7 ev': 3108,
  '长安v3 ev': 3109,
  '长安v5 ev': 3110,
  东风小康d51: 3124,
  东风小康d52: 3125,
  长安凯程f70: 3126,
  依维柯褒迪ev: 3127,
  凯迪拉克xt6: 3164,
  '风景v5 ev': 3183,
  沃尔沃xc40: 3355,
  奔驰a级amg: 3360,
  '昂希诺 纯电动': 3377,
  国机智骏gx5: 3408,
  国机智骏gc1: 3409,
  国机智骏gc2: 3410,
  飞行家phev: 3481,
  '宋max ev': 3488,
  'aion lx': 3503,
  '宋pro dm': 3504,
  '宋pro ev': 3505,
  指挥官phev: 3528,
  '新宝骏rm-5': 3734,
  凯迪拉克ct5: 3736,
  '新宝骏rc-6': 3739,
  长安欧尚科赛5: 3754,
  长安欧尚科赛3: 3755,
  'model 3': 3762,
  广汽丰田ia5: 4087,
  '新宝骏rs-3': 4162,
  savana: 10,
  sierra: 11,
  giulia: 56,
  '奥迪rs 5': 92,
  '奥迪rs 6': 93,
  '奥迪rs 7': 94,
  宝马3系gt: 117,
  '宝马x5 m': 139,
  '宝马x6 m': 140,
  保时捷911: 157,
  保时捷718: 161,
  北京bj20: 163,
  北京bj40: 164,
  北京bj80: 165,
  北汽幻速s2: 166,
  北汽幻速s3: 167,
  北汽幻速s5: 169,
  北汽幻速s6: 170,
  北汽幻速h2: 171,
  北汽幻速h3: 173,
  北汽幻速h6: 175,
  'bj 212': 202,
  奔驰cla级: 220,
  奔驰cls级: 223,
  奔驰slc级: 238,
  'amg gt': 260,
  '本田xr-v': 279,
  '本田cr-v': 280,
  '本田ur-v': 281,
  标致508l: 337,
  标致2008: 338,
  标致3008: 339,
  标致4008: 340,
  标致5008: 341,
  福瑞达k21: 364,
  福瑞达k22: 365,
  tiguan: 384,
  '高尔夫·嘉旅': 411,
  锐骐多功能车: 430,
  风行s500: 447,
  风行f600: 448,
  法拉利488: 494,
  法拉利812: 503,
  丰田rav4: 546,
  rav4荣放: 546,
  启腾ex80: 559,
  江铃e160: 787,
  小海狮x30: 814,
  海狮x30l: 815,
  '卡尔森 s级': 837,
  全球鹰k12: 868,
  全球鹰k17: 869,
  雷克萨斯ct: 886,
  雷克萨斯is: 887,
  雷克萨斯es: 888,
  雷克萨斯gs: 889,
  雷克萨斯ls: 890,
  雷克萨斯nx: 891,
  雷克萨斯rx: 894,
  雷克萨斯lx: 895,
  雷克萨斯rc: 896,
  '卡缤(进口)': 908,
  猎豹cs10: 941,
  '天语 sx4': 971,
  ghibli: 1017,
  '优6 suv': 1043,
  '大7 mpv': 1046,
  huayra: 1065,
  启辰m50v: 1109,
  荣威e950: 1179,
  荣威erx5: 1827,
  斯巴鲁brz: 1234,
  沃尔沃v40: 1267,
  沃尔沃v60: 1270,
  沃尔沃v90: 1273,
  沃尔沃s60: 1279,
  沃尔沃s90: 1281,
  五菱荣光小卡: 1288,
  五菱之光小卡: 1289,
  现代ix25: 1321,
  现代ix35: 1323,
  雪铁龙c4l: 1369,
  'ds 5ls': 1386,
  野马ec70: 1392,
  驭胜s350: 1444,
  长安cs15: 1460,
  长安cs35: 1461,
  长安cs75: 1462,
  长安cs95: 1463,
  新豹mini: 1466,
  中华h530: 1516,
  众泰e200: 1539,
  众泰z360: 1544,
  众泰z560: 1546,
  众泰z700: 1548,
  众泰t600: 1552,
  众泰t700: 1559,
  宝骏310w: 1565,
  海马爱尚ev: 1583,
  北斗星x5e: 1591,
  宝骏e100: 1592,
  长安cs55: 1599,
  众泰t300: 1610,
  众泰t500: 1617,
  五菱宏光s3: 1626,
  野马ec30: 1631,
  '奥迪rs 3': 1635,
  '丰田c-hr': 1636,
  宝马6系gt: 1639,
  北汽幻速s7: 1640,
  'u5 suv': 1652,
  骐铃t100: 1676,
  北汽幻速h5: 1688,
  espace: 1694,
  骏派a70e: 1696,
  华骐300e: 1698,
  雷克萨斯lc: 1704,
  风光s560: 1712,
  '奥迪rs 4': 1728,
  北汽昌河a6: 1754,
  睿行s50t: 1784,
  'wey p8': 1796,
  揽胜phev: 1801,
  北汽昌河q7: 1807,
  帝豪phev: 1824,
  金旅海狮ev: 1838,
  祺智phev: 1916,
  庆铃taga: 1920,
  'e-golf': 1933,
  长安欧尚科赛: 1990,
  宝沃bxi7: 2037,
  骏派cx65: 2181,
  雷克萨斯ux: 2203,
  ranger: 2490,
  众泰t800: 2655,
  添越phev: 2726,
  鑫源x30l: 2810,
  博瑞phev: 2814,
  小鹏汽车g3: 2819,
  奕泽izoa: 2827,
  思皓e20x: 2866,
  '雷凌双擎e+': 2882,
  蓝舰t340: 2923,
  俊风er30: 2924,
  五菱荣光新卡: 2962,
  全球鹰ex3: 2967,
  长安欧尚科尚: 2968,
  睿行em80: 2972,
  俊风e11k: 2983,
  东南a5翼舞: 2990,
  宝骏e200: 2992,
  野马ec60: 3003,
  长安星卡ev: 3015,
  大乘g70s: 3024,
  大乘g60e: 3025,
  长安欧尚长行: 3057,
  柯迪亚克gt: 3061,
  全球鹰k27: 3073,
  世锐phev: 3097,
  'aion s': 3101,
  蔚揽phev: 3106,
  捷途x70s: 3117,
  嘉际phev: 3121,
  '高尔夫·纯电': 3147,
  '宝马x3 m': 3175,
  '宝马x4 m': 3176,
  宝马x4m: 3176,
  鑫源t20s: 3197,
  鑫源t22s: 3198,
  鑫源t30s: 3199,
  鑫源t32s: 3200,
  成功bev6: 3201,
  大乘g60s: 3364,
  领动phev: 3378,
  长安欧尚x7: 3389,
  江淮iev7: 3587,
  星越phev: 3595,
  taycan: 3663,
  缤越phev: 3706,
  睿行es30: 3731,
  谢尔比gte: 3757,
  锐骐皮卡ev: 3761,
  长安星卡l1: 4152,
  长安星卡c系: 4153,
  铂驰nv系列: 4190,
  睿行em60: 4205,
  铂驰sp系列: 4229,
  '腾势x ev': 4305,
  'ds 4s': 5,
  yukon: 9,
  'x-bow': 25,
  名爵3sw: 29,
  奥迪tts: 90,
  奥迪a4l: 96,
  奥迪a6l: 99,
  宝骏310: 108,
  宝骏510: 110,
  宝骏730: 114,
  宝沃bx5: 150,
  宝沃bx7: 151,
  macan: 154,
  绅宝d50: 177,
  绅宝d70: 179,
  绅宝x25: 183,
  绅宝x35: 184,
  绅宝x65: 185,
  奔驰gla: 215,
  奔驰glc: 216,
  奔驰gle: 228,
  奔驰gls: 233,
  奔驰sl级: 242,
  迈巴赫s级: 264,
  奔腾b50: 265,
  奔腾b30: 266,
  奔腾b70: 267,
  奔腾b90: 268,
  奔腾x40: 269,
  奔腾x80: 270,
  比亚迪f3: 307,
  比亚迪e6: 319,
  标致308: 333,
  标致301: 335,
  标致408: 336,
  别克gl8: 353,
  风光370: 435,
  风光580: 436,
  风光330: 437,
  景逸s50: 439,
  风行sx6: 443,
  风行cm7: 446,
  东南dx3: 484,
  东南dx7: 485,
  hiace: 530,
  雄师f16: 555,
  雄师f22: 556,
  启腾v60: 557,
  启腾m70: 558,
  新世代全顺: 574,
  伽途im6: 597,
  伽途im8: 598,
  伽途ix7: 600,
  伽途ix5: 601,
  传祺ga6: 612,
  传祺ga8: 613,
  传祺gs5: 614,
  传祺gs4: 616,
  传祺gs8: 617,
  财运500: 628,
  财运300: 629,
  财运100: 630,
  哈弗h2s: 645,
  海格h5c: 656,
  海格h7v: 657,
  海格h5v: 658,
  海格h6c: 659,
  海格h6v: 660,
  福仕达福卡: 680,
  福仕达腾达: 681,
  瑞风a60: 759,
  捷豹xfl: 798,
  金杯f50: 800,
  金杯大海狮: 802,
  海星t20: 806,
  海星t22: 807,
  金杯t30: 808,
  金杯t32: 809,
  金杯t50: 810,
  金杯t52: 811,
  智尚s35: 817,
  金杯s70: 818,
  大力神k5: 824,
  海格h4e: 828,
  金旅大海狮: 831,
  卡升c10: 840,
  开瑞k60: 844,
  开瑞k50: 845,
  力帆820: 921,
  力帆x60: 922,
  力帆x50: 923,
  力帆x80: 925,
  猎豹cs9: 938,
  猎豹ct7: 949,
  林肯mkz: 950,
  林肯mkc: 954,
  林肯mkx: 955,
  超级维特拉: 967,
  揽胜运动版: 992,
  evora: 996,
  讴歌cdx: 1048,
  讴歌mdx: 1056,
  讴歌nsx: 1057,
  奇瑞eq1: 1101,
  启辰t70: 1106,
  启辰t90: 1108,
  起亚kx5: 1124,
  起亚kx7: 1125,
  前途k50: 1139,
  日产d22: 1169,
  荣威360: 1174,
  荣威950: 1178,
  荣威ei6: 1181,
  荣威rx5: 1182,
  劲炫asx: 1198,
  斯巴鲁xv: 1230,
  英致737: 1263,
  英致727: 1264,
  五菱荣光v: 1293,
  五菱之光v: 1294,
  'd-max': 1297,
  五十铃皮卡: 1300,
  迈锐宝xl: 1355,
  雪铁龙c5: 1374,
  雪铁龙c6: 1375,
  野马t70: 1391,
  野马t80: 1393,
  骏派a70: 1402,
  骏派d60: 1403,
  佳宝t57: 1408,
  佳宝t51: 1409,
  佳宝t50: 1410,
  解放t80: 1411,
  佳宝v55: 1412,
  佳宝v52: 1413,
  佳宝v80: 1414,
  佳宝v75: 1415,
  佳宝v77: 1416,
  依维柯得意: 1418,
  依维柯褒迪: 1419,
  长安之星9: 1480,
  睿行s50: 1481,
  神骐t20: 1482,
  神骐f30: 1483,
  睿行m80: 1486,
  睿行m90: 1487,
  睿行m70: 1488,
  之诺60h: 1506,
  众泰sr7: 1553,
  众泰sr9: 1554,
  易至ex5: 1587,
  传祺gs7: 1590,
  传祺ge3: 1598,
  欧力威ev: 1600,
  伊兰特ev: 1601,
  艾瑞泽5e: 1609,
  蔚来es8: 1616,
  荣威rx3: 1619,
  别克gl6: 1620,
  传祺gs3: 1621,
  启辰d60: 1628,
  威途x35: 1630,
  御风p16: 1637,
  福美来f7: 1715,
  成功v2e: 1737,
  宝沃bx6: 1747,
  君马s70: 1748,
  国金gm3: 1758,
  荣威ei5: 1760,
  御风s16: 1765,
  骏派a50: 1766,
  裕路ev2: 1773,
  依维柯欧胜: 1777,
  宝骏530: 1781,
  捷豹xel: 1789,
  传祺gm8: 1794,
  宝骏360: 1804,
  瑞虎3xe: 1818,
  图雅诺ev: 1826,
  卡威ev1: 1840,
  威马ex5: 1915,
  开沃d08: 1922,
  开沃d09: 1923,
  开沃d10: 1924,
  传祺ga4: 1931,
  零跑s01: 1934,
  捷途x70: 1938,
  骏派d80: 1939,
  英致ex1: 1988,
  红旗hs7: 2151,
  荣威rx8: 2248,
  昌河北斗星: 2582,
  风光ix5: 2813,
  '轩逸·纯电': 2815,
  福美来f5: 2824,
  mattu: 2829,
  艾瑞泽gx: 2830,
  传祺gm6: 2832,
  蔚来es6: 2843,
  威马ex6: 2846,
  捷途x90: 2849,
  捷途x95: 2850,
  广汽ix4: 2854,
  北汽ev5: 2858,
  奔腾t77: 2867,
  奥迪q5l: 2916,
  帝豪gse: 2920,
  奥迪q2l: 2963,
  哪吒n01: 2964,
  启辰t60: 2970,
  讴歌rdx: 2987,
  宇通cl6: 2995,
  风行t5l: 3004,
  大乘e20: 3026,
  易至ev3: 3028,
  俊风e17: 3032,
  理想one: 3059,
  哈弗f7x: 3070,
  天际me7: 3075,
  九龙em3: 3090,
  恒好ev1: 3135,
  恒好ev7: 3136,
  神骐t10: 3148,
  解放t90: 3149,
  大乘g60: 3150,
  新时代海狮: 3154,
  红旗hs5: 3159,
  开云电皮卡: 3163,
  捷达vs5: 3171,
  捷达va3: 3172,
  比亚迪e1: 3174,
  法拉利f8: 3177,
  海狮z系列: 3180,
  五菱宏光v: 3192,
  比亚迪s2: 3233,
  北斗星x5: 3269,
  '宝来·纯电': 3278,
  昂科拉gx: 3330,
  睿行m60: 3357,
  '雷诺 e诺': 3369,
  启辰e30: 3452,
  比亚迪e2: 3455,
  奔腾t99: 3474,
  名爵ehs: 3715,
  奔驰eqc: 3719,
  奔腾t33: 3722,
  迈凯伦gt: 3758,
  evija: 3760,
  跨越王x3: 3864,
  跨越王x5: 3872,
  北京f40: 3939,
  风光ix7: 4000,
  东南dx5: 4068,
  比亚迪e3: 4076,
  比德文e3: 4090,
  铂驰v系列: 4128,
  迈莎锐g级: 4133,
  跨越王x1: 4161,
  北斗星快闪: 4175,
  柯米克gt: 4180,
  跨越者d5: 4192,
  潍柴u70: 4209,
  小海狮ev: 4293,
  'ds 5': 6,
  'ds 6': 7,
  名爵zs: 34,
  mini: 38,
  奥迪s3: 74,
  奥迪a5: 76,
  奥迪s5: 77,
  奥迪s6: 79,
  奥迪a7: 80,
  奥迪s7: 81,
  奥迪a8: 82,
  奥迪q7: 87,
  奥迪tt: 89,
  奥迪r8: 91,
  奥迪a3: 95,
  奥迪q3: 100,
  宝马4系: 118,
  宝马6系: 121,
  宝马7系: 122,
  宝马x4: 125,
  宝马x6: 127,
  宝马x5: 128,
  宝马2系: 131,
  宝马z4: 132,
  宝马i3: 133,
  宝马i8: 134,
  宝马m3: 135,
  宝马m4: 136,
  宝马m5: 137,
  宝马m2: 141,
  宝马1系: 143,
  宝马3系: 145,
  宝马5系: 146,
  宝马x1: 148,
  战旗皮卡: 211,
  奔驰c级: 212,
  奔驰e级: 214,
  奔驰b级: 219,
  奔驰s级: 224,
  奔驰g级: 230,
  奔驰v级: 245,
  比速t3: 293,
  比速m3: 294,
  比速t5: 295,
  成功k1: 369,
  成功k2: 370,
  成功x1: 371,
  成功v1: 372,
  成功v2: 373,
  polo: 391,
  大众cc: 416,
  东风a9: 422,
  东风皮卡: 425,
  御风ev: 427,
  锐骐皮卡: 429,
  景逸x5: 442,
  v3菱悦: 477,
  v5菱致: 479,
  普瑞维亚: 524,
  丰田86: 529,
  威驰fs: 539,
  风景v3: 589,
  风景v5: 590,
  福田风景: 591,
  蒙派克e: 592,
  蒙派克s: 593,
  风景g7: 594,
  风景g9: 595,
  星旺m1: 626,
  星旺m2: 627,
  星旺cl: 633,
  哈弗h2: 646,
  哈弗h5: 648,
  哈弗h6: 649,
  哈弗h7: 651,
  哈弗h9: 653,
  海马s7: 668,
  海马m3: 675,
  海马e3: 676,
  海马m6: 677,
  海马s5: 679,
  汉腾x7: 682,
  途腾t1: 685,
  途腾t2: 686,
  途腾t3: 687,
  红旗h7: 690,
  华凯皮卡: 692,
  黄海n1: 715,
  黄海n2: 716,
  帝豪gl: 734,
  帝豪ev: 735,
  帝豪gs: 740,
  远景x6: 742,
  远景x1: 747,
  瑞风s3: 760,
  瑞风s2: 763,
  瑞风s5: 765,
  瑞风m3: 768,
  瑞风m4: 769,
  瑞风m5: 770,
  帅铃t6: 775,
  瑞风s7: 778,
  骐铃t5: 783,
  骐铃t7: 784,
  骐铃t3: 785,
  捷豹xe: 790,
  捷豹xf: 792,
  捷豹xj: 794,
  金杯海狮: 803,
  金杯快运: 804,
  西部牛仔: 819,
  金旅海狮: 829,
  九龙a5: 833,
  九龙a6: 834,
  九龙a4: 836,
  卡威k1: 842,
  优优2代: 849,
  凯翼x3: 864,
  凯翼v3: 865,
  猎豹q6: 944,
  林肯大陆: 952,
  陆风x5: 977,
  陆风x7: 979,
  陆风x8: 981,
  陆风x2: 983,
  揽胜星脉: 989,
  揽胜极光: 993,
  发现神行: 994,
  艾瑞泽5: 1081,
  艾瑞泽7: 1082,
  瑞虎3x: 1092,
  起亚k2: 1115,
  起亚k3: 1116,
  起亚k5: 1119,
  荣威i6: 1180,
  柯迪亚克: 1245,
  英致g3: 1261,
  英致g5: 1262,
  五菱宏光: 1290,
  五菱荣光: 1291,
  五菱之光: 1292,
  悦纳rv: 1307,
  索纳塔九: 1319,
  新凯威霆: 1344,
  新凯凌特: 1345,
  乐风rv: 1349,
  c4世嘉: 1370,
  夏利n5: 1395,
  威志v5: 1396,
  夏利n7: 1397,
  森雅r7: 1406,
  逸动ev: 1456,
  长安v5: 1468,
  长安v3: 1469,
  长安星卡: 1473,
  知豆d2: 1509,
  中华h3: 1517,
  中华v3: 1523,
  云100: 1540,
  大迈x5: 1555,
  大迈x7: 1556,
  卡升t6: 1581,
  奔奔ev: 1593,
  哈弗m6: 1594,
  黄海n3: 1595,
  卡升威霆: 1596,
  宇通t7: 1597,
  远景x3: 1614,
  英格尼斯: 1618,
  领克01: 1622,
  领克03: 1623,
  宋max: 1624,
  睿骋cc: 1625,
  汉腾x5: 1629,
  圣达菲7: 1632,
  宝马8系: 1641,
  urus: 1643,
  奥迪q8: 1646,
  道达v8: 1648,
  凯翼x5: 1663,
  远景s1: 1671,
  奥迪s4: 1684,
  lite: 1686,
  圣达菲5: 1695,
  红旗h5: 1701,
  云度π1: 1713,
  云度π3: 1714,
  星途tx: 1722,
  瑞虎5x: 1738,
  好运1号: 1771,
  知豆d3: 1786,
  凯翼e3: 1787,
  瑞风m6: 1788,
  陆风逍遥: 1791,
  哈弗h4: 1798,
  'ds 7': 1805,
  中华v6: 1812,
  九龙e6: 1830,
  凯歌ev: 1831,
  福家ev: 1836,
  领途e行: 1890,
  威麟h5: 1900,
  全界q1: 1932,
  大指挥官: 1975,
  瑞风r3: 1986,
  勇士皮卡: 1989,
  北斗星e: 2039,
  '幸福e+': 2143,
  优优ev: 2257,
  逸动dt: 2315,
  江淮v7: 2375,
  宝马m8: 2592,
  领克02: 2765,
  森雅r9: 2793,
  中华v7: 2809,
  伽途gt: 2811,
  宝马x3: 2812,
  风行t5: 2820,
  宝马x7: 2825,
  海马8s: 2828,
  哈弗f5: 2859,
  风行m7: 2873,
  汉腾v7: 2879,
  风行m6: 2894,
  路盛s1: 2900,
  欧拉iq: 2910,
  欧拉r1: 2911,
  奔驰a级: 2913,
  凯锐浩克: 2921,
  优劲ev: 2922,
  威麟h6: 2926,
  九龙c6: 2927,
  帅铃t8: 2931,
  名爵hs: 2941,
  闪闪x2: 2960,
  帅客ev: 2973,
  哈弗f7: 2991,
  逸动xt: 2999,
  特顺ev: 3005,
  秦pro: 3007,
  欧诺ev: 3014,
  祺智ev: 3020,
  荣威i5: 3041,
  傲跑ev: 3047,
  迈威ev: 3054,
  瑞风s4: 3069,
  星途lx: 3083,
  逸动et: 3086,
  陆风荣曜: 3139,
  宋pro: 3195,
  朗逸纯电: 3277,
  风光e3: 3366,
  领界ev: 3367,
  银隆艾菲: 3707,
  宝马x2: 3708,
  黄海n7: 3729,
  嘉悦a5: 3735,
  风景g5: 3742,
  雷丁i3: 3745,
  雷丁i5: 3746,
  远程e5: 3766,
  远程e6: 3767,
  新豹t3: 3863,
  艾瑞泽e: 4086,
  海豚ev: 4154,
  锐程cc: 4188,
  御风房车: 4207,
  风光e1: 4224,
  好运2号: 4292,
  上喆v级: 4299,
  牧马人: 14,
  自由侠: 22,
  指南者: 23,
  自由光: 24,
  名爵3: 30,
  名爵6: 32,
  图雅诺: 247,
  艾力绅: 282,
  奥德赛: 291,
  秦dm: 305,
  唐dm: 311,
  宋dm: 315,
  昂科拉: 351,
  昂科威: 352,
  甲壳虫: 376,
  迈特威: 387,
  凯路威: 388,
  桑塔纳: 394,
  帕萨特: 398,
  途观l: 404,
  途安l: 407,
  高尔夫: 410,
  埃尔法: 525,
  凯美瑞: 535,
  汉兰达: 536,
  卡罗拉: 542,
  普拉多: 547,
  柯斯达: 549,
  撼路者: 572,
  途睿欧: 573,
  福克斯: 577,
  福睿斯: 578,
  蒙迪欧: 579,
  金牛座: 582,
  萨瓦纳: 596,
  拓陆者: 599,
  观致3: 602,
  观致5: 603,
  星旺l: 634,
  福美来: 662,
  华颂7: 698,
  大柴神: 712,
  域虎7: 781,
  阁瑞斯: 801,
  小金牛: 820,
  考斯特: 835,
  古思特: 883,
  科雷傲: 900,
  科雷嘉: 901,
  领航员: 957,
  维特拉: 975,
  阿特兹: 1007,
  瑞虎3: 1091,
  瑞虎7: 1094,
  福瑞迪: 1114,
  纳瓦拉: 1171,
  欧蓝德: 1199,
  雷斯特: 1225,
  森林人: 1231,
  康恩迪: 1325,
  科鲁兹: 1352,
  科沃兹: 1353,
  迈锐宝: 1354,
  科帕奇: 1358,
  探界者: 1359,
  库罗德: 1363,
  索罗德: 1364,
  科迈罗: 1365,
  爱丽舍: 1367,
  跨越王: 1467,
  欧诺s: 1475,
  风骏5: 1503,
  风骏6: 1504,
  小老虎: 1533,
  大领主: 1534,
  柯珞克: 1661,
  斯派卡: 1705,
  路易斯: 1767,
  秦ev: 1820,
  宋ev: 1821,
  元ev: 1833,
  航海家: 1955,
  库里南: 2069,
  威尔法: 2163,
  飞行家: 2778,
  瑞虎8: 2794,
  柯米克: 2826,
  沃兰多: 2965,
  指挥官: 2969,
  祥菱v: 2976,
  域虎3: 3017,
  域虎5: 3018,
  锐骐6: 3030,
  海狮s: 3034,
  风骏7: 3044,
  亚洲龙: 3068,
  唐ev: 3077,
  尼欧ⅱ: 3084,
  科鲁泽: 3094,
  祥菱s: 3134,
  几何a: 3157,
  勇猛者: 3162,
  瑞虎e: 3387,
  域虎9: 3393,
  途昂x: 3435,
  祥菱m: 3692,
  科雷缤: 3738,
  腾势x: 3873,
  昂科旗: 4080,
  新豹3: 4173,
  锐行: 33,
  锐腾: 35,
  战旗: 203,
  勇士: 205,
  陆霸: 208,
  锐铃: 209,
  越铃: 210,
  威霆: 244,
  凌特: 246,
  哥瑞: 274,
  竞瑞: 275,
  思域: 276,
  杰德: 277,
  飞度: 283,
  锋范: 286,
  凌派: 287,
  缤智: 288,
  雅阁: 289,
  冠道: 292,
  速锐: 304,
  凯越: 343,
  英朗: 344,
  威朗: 345,
  君越: 347,
  君威: 348,
  慕尚: 354,
  飞驰: 355,
  添越: 357,
  欧陆: 358,
  蔚揽: 380,
  途锐: 385,
  夏朗: 386,
  朗逸: 393,
  凌渡: 397,
  辉昂: 402,
  途观: 403,
  途昂: 405,
  捷达: 408,
  宝来: 409,
  速腾: 414,
  迈腾: 415,
  酷威: 420,
  虎视: 424,
  御风: 426,
  帅客: 428,
  俊风: 431,
  菱智: 445,
  致悦: 509,
  菲翔: 510,
  雷凌: 534,
  威驰: 538,
  皇冠: 544,
  揽福: 552,
  全顺: 575,
  翼搏: 583,
  翼虎: 584,
  锐界: 585,
  萨普: 588,
  星旺: 632,
  御骏: 654,
  龙威: 655,
  傲骏: 714,
  瑞途: 717,
  金刚: 722,
  远景: 729,
  帝豪: 733,
  博越: 741,
  凌铃: 771,
  瑞风: 776,
  星锐: 777,
  宝典: 780,
  特顺: 782,
  金典: 822,
  凯歌: 825,
  金威: 826,
  凯特: 827,
  艾菲: 832,
  优优: 848,
  幻影: 882,
  魅影: 884,
  曜影: 885,
  迈威: 924,
  轩朗: 926,
  乐途: 932,
  雨燕: 970,
  启悦: 973,
  揽胜: 991,
  // 总裁: 1018,
  锐3: 1041,
  纳5: 1042,
  优劲: 1066,
  傲跑: 1121,
  智跑: 1123,
  骊威: 1141,
  日产阳光: 1142,
  轩逸: 1145,
  蓝鸟: 1146,
  天籁: 1147,
  西玛: 1148,
  逍客: 1150,
  奇骏: 1151,
  楼兰: 1152,
  龙锐: 1209,
  福家: 1210,
  力狮: 1229,
  傲虎: 1232,
  晶锐: 1238,
  昕锐: 1239,
  昕动: 1240,
  明锐: 1241,
  速派: 1243,
  腾势: 1256,
  瑞迈: 1298,
  瑞纳: 1304,
  悦纳: 1306,
  悦动: 1311,
  领动: 1313,
  名图: 1314,
  途胜: 1322,
  胜达: 1324,
  赛欧: 1347,
  创酷: 1357,
  坤程: 1417,
  奔奔: 1446,
  悦翔: 1454,
  逸动: 1455,
  睿骋: 1459,
  凌轩: 1464,
  威虎: 1531,
  芝麻: 1537,
  骁途: 1562,
  劲客: 1579,
  凯绅: 1700,
  焕驰: 1719,
  阅朗: 1745,
  嘉际: 2167,
  博骏: 2258,
  迈迈: 2696,
  途达: 2702,
  博瑞: 2799,
  探岳: 2835,
  途岳: 2836,
  铃拓: 2841,
  奕跑: 2890,
  逸行: 2897,
  战车: 2905,
  战剑: 2906,
  缤瑞: 2928,
  奕歌: 2932,
  迈图: 2966,
  缤越: 2975,
  领界: 2982,
  智行: 3008,
  观境: 3074,
  享域: 3095,
  星越: 3152,
  创界: 3341,
  微蓝: 3359,
  奕炫: 3365,
  领特: 3957,
  旷世: 4112,
  迈乔: 4171,
  // "元": 312,
  // 宋: 314,
  // 唐: 2869,
  // 炮: 3332,
  // 秦: 4118,
}
